var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcnAdmin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.52,
    height: 21.399,
    viewBox: "0 0 18.52 21.399",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b,.e{fill:none;}.a,.b{stroke:#51b2cd;stroke-width:2px;}.b{stroke-linecap:round;}.c{fill:#0fb4d1;fill-rule:evenodd;}.d{stroke:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.294)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(3.57)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 5,
    cy: 5,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 5,
    cy: 5,
    r: 4
  })), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M10.093.529S1.6-2.74,0,6.978",
    transform: "translate(0 13.158) rotate(-9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M264.111,5.481a1.1,1.1,0,1,0-1.1-1.1A1.1,1.1,0,0,0,264.111,5.481Zm-2.247-3.508a3.091,3.091,0,0,1,1.315-.713L263.617,0h1.1l.438,1.261a3.827,3.827,0,0,1,1.315.713l1.315-.274.548.987-.877.987a3.125,3.125,0,0,1,.055.713c0,.219-.055.493-.055.713l.877.987-.548.987L266.467,6.8a3.091,3.091,0,0,1-1.315.713l-.438,1.261h-1.1l-.438-1.261a3.828,3.828,0,0,1-1.315-.713l-1.315.274L260,6.084l.877-.987a3.125,3.125,0,0,1-.055-.713c0-.219.055-.493.055-.713L260,2.686l.548-.987Z",
    transform: "translate(-251.105 12.629)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnAdmin);
export default __webpack_public_path__ + "static/media/icn-admin.cfdd07531cf794ef3235915fa6341dde.svg";
export { ForwardRef as ReactComponent };